
import GlobalTable from '@/components/probaworkflows_base_components/GlobalTable/GlobalTable.vue';
import {
  CREATE_ENTITY_TYPE_WORKFLOW,
  get_headers,
  get_project_id,
  get_token,
  UPDATE_ENTITY_TYPE_WORKFLOW,
  VIEW_ENTITY_TYPE_WORKFLOWS, GET_FORMS, ASSIGN_ENTITY_TYPE_WORKFLOW_FORM, UNASSIGN_ENTITY_TYPE_WORKFLOW_FORM, VIEW_ENTITY_TYPE_WORKFLOW_FORM
} from '@/utils/constants/constants.js';
import alert_mixin from '@/utils/mixins/alert_mixin';
import {
  validate_non_empty_string,
} from '@/utils/validations/validate_inputs';
import axios from 'axios';
import Swal from 'sweetalert2';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import 'datatables.net';
import $ from 'jquery';

export default{
  name: 'ManageApprovalRules',
  mixins: [alert_mixin],
  components: {
    GlobalTable
  },
  data: () =>({
    headers: get_headers(),
    token: get_token(),
    project_id: get_project_id(),
    workflow_name: '',
    workflow_description  : '',
    entity_type_id: sessionStorage.getItem('entity_type_id'),
    workflows: [],
    workflow_id: null,
    update_workflow_name: '',
    update_workflow_description: '',
    form_list: [],
    workflow_form_list: [],
    selected_workflow_id: null,
    form_id: sessionStorage.getItem('form_id'),
    assigned_workflow_forms: [],
  }),
  mounted(){
    this.view_entity_type_workflows();
    this.get_forms();
  },
    
  methods: {
    async create_entity_type_workflow(){
      if (!validate_non_empty_string(this.workflow_name)) {
        this.show_error('Workflow name must not be empty');
        return;
      }

      if (!validate_non_empty_string(this.workflow_description)) {
        this.show_error('Workflow description must not be empty');
        return;
      }

      const payload = {
        project_id: this.project_id,
        name: this.workflow_name, 
        description: this.workflow_description,
        entity_type_id: this.entity_type_id
      };
    
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Token ${this.token}`
      };
    
      try {
        let response = await axios.post(CREATE_ENTITY_TYPE_WORKFLOW, payload, { headers });
    
        const response_data = response.data;
        if(response_data.status === 'success') { 
          this.show_success('Workflow created successfully.');
          this.close_modal('create_workflow');
          window.location.reload();

    
        } else {
          this.show_error('Error during workflow creation');
          this.close_modal('create_workflow');
          window.location.reload();
        }
      } catch (error) {
        this.show_error(`Error creating workflow: ${error.response?.data?.message}`);
      } 
    },
    
    
    async view_entity_type_workflows() {    
      const payload = {
        project_id: this.project_id,
        entity_type_id: this.entity_type_id
      };
    
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Token ${this.token}`
      };
    
      this.loading = true;
      try {
        let response = await axios.get(VIEW_ENTITY_TYPE_WORKFLOWS, {
          headers,
          params: payload
        });
    
        this.workflows = response.data.data.list_entity_types.map((workflow) => ({
          id: workflow.id,
          workflow_name: workflow.name,
          workflow_description: workflow.description
        }));
        this.assigned_workflow_forms = response.data.data.workflow_assigned_forms.map((workflow) => ({
          id: workflow.id,
          workflow_id: workflow.entity_workflow_id,
          form_id: workflow.form_id,
          workflow_name: workflow.workflow_name,
        }));
    
      } catch (error) {
        this.show_error(`Error fetching workflows: ${error.response?.data?.message}`);
      }
    },

    prepopulate_edit_workflow_modal(row) {
      const original_workflow = this.workflows.find(type => type.id === row.id);
      if (original_workflow) {
          this.update_workflow_name = original_workflow.workflow_name;
          this.update_workflow_description = original_workflow.workflow_description;
          this.workflow_id = original_workflow.id;
      }
    },

    validate_updated_workflow_inputs() {
      if (!validate_non_empty_string(this.update_workflow_name)) {
        this.show_error('Workflow name must not be empty');
        return false;
      }
    
      if (!validate_non_empty_string(this.update_workflow_description)) {
        this.show_error('Workflow description must not be empty');
        return false;
      }
    
      return true;
    },
    
    async update_entity_type_workflow(){
      if (!this.validate_updated_workflow_inputs()) return;

      var new_workflow_name = this.update_workflow_name;
      var new_workflow_description = this.update_workflow_description;
      var edit_workflow_id = this.workflow_id;

      const payload = {
        name: new_workflow_name,
        description: new_workflow_description,
        workflow_id: edit_workflow_id
      }

      try {
        let response = await axios.post(UPDATE_ENTITY_TYPE_WORKFLOW, payload, {
          headers: this.headers
        });
        const response_data = response.data;
        if (response_data.status === 'success') {
          this.show_success('Workflow updated successfully.');
          this.close_modal('update_workflow')
          window.location.reload();
        } else {
          this.show_error('Error during while updating workflow');
        }        
      } catch (error) {
        this.show_error(`Error updating workflow: ${error.response?.data?.message}`);
      }
    },
    redirect_to_manage_workflows(workflow_id) {
      const workflow = this.workflows.find(current_workflow => current_workflow.id === workflow_id)
      if(workflow){
        sessionStorage.setItem('workflow_id', workflow_id);
        sessionStorage.setItem('workflow_name', workflow.workflow_name);
        this.$router.push('/manage_workflows');
      }
    },

    initialize_data_table() {
      this.$nextTick(() => {
        const table_id ='#assign_workflow_table'
    
        if (document.querySelector(table_id)) {
          if ($.fn.DataTable.isDataTable(table_id)) {
            $(table_id).DataTable().destroy(); // Destroy previous DataTable instance
          }
          $(table_id).DataTable(); // Reinitialize DataTable
        }
      });
    },

    async get_forms() {
      const payload = { project_id: this.project_id };
    
      try {
        let response = await axios.get(GET_FORMS, {
          headers: this.headers,
          params: payload
        });
    
        // Manually parse the response
        const parsed_response = JSON.parse(response.data);    
        this.form_list = parsed_response.data.map((form) => ({
          id: form.id,
          name: form.form_name
        }));
        
        setTimeout(() => {
          Swal.close();
          this.initialize_data_table();
        }, 300);
    
      } catch (error) {
        this.show_error(`Error fetching status: ${error.response?.data?.message || error.message}`);
      }
    },

    handle_assignment_toggle(form) {
      if (!form.is_assigned) {
        this.unassign_entity_type_workflow_form(form);
        return;
      }

      const assignedForm = this.assigned_workflow_forms.find(
        (f) => f.form_id === form.id
      );

      if (assignedForm) {
        const text = `Form is already assigned to "${assignedForm.workflow_name}" workflow.
                      Do you want to reassign it to this workflow?`;
        this.show_info(text);

        return;
      }

      // Safe to assign directly
      this.assign_entity_type_workflow_form(form);
    },


    async assign_entity_type_workflow_form(form) {
      const payload = {
        entity_workflow_id: this.selected_workflow_id,
        form_id: form.id,
        assigner_id: 1, // Replace with actual user ID if needed
      };
    
      try {
        const response = await axios.post(ASSIGN_ENTITY_TYPE_WORKFLOW_FORM, payload, {
          headers: this.headers,
        });
    
        if (response.data.status === 'success') {
          this.show_success('Workflow assigned to form successfully!');
        } else {
          this.show_error('Error while assigning workflow');
          form.is_assigned = false;
        }
      } catch (error) {
        this.show_error(`Error assigning workflow to form: ${error.response?.data?.message}`);
        form.is_assigned = false;
      }
    },

    async view_entity_type_workflow_form(selected_workflow_id) {
      this.selected_workflow_id = selected_workflow_id;
      const payload = {
        project_id: this.project_id,
        entity_workflow_id: this.selected_workflow_id
      };

      try {
        let response = await axios.post(VIEW_ENTITY_TYPE_WORKFLOW_FORM, payload, {
          headers: this.headers,
          params: payload,
        });
        const data = response.data.data.available_forms.map((form) => ({
          id: form.form_id,
          name: form.form_name,
          is_assigned: !!form.is_assigned,
          entity_workflow_form_id: form.entity_workflow_form_id 
        }));
    
        this.forms = data;
        this.form_list = this.form_list.map(form => {
          const match = data.find(new_form => new_form.id === form.id);
          return {
            ...form,
            is_assigned: match ? match.is_assigned : false,
            entity_workflow_form_id: match ? match.entity_workflow_form_id : null  // Update this as well
          };
        });
    
        return data;   
    
      } catch (error) {
        this.show_error('Error fetching roles: ' + error.message);
      }
    },
    
    
    async unassign_entity_type_workflow_form(form){
      const payload = {
        entity_workflow_form_id: form.entity_workflow_form_id  
      };

      try {
        let response = await axios.post(UNASSIGN_ENTITY_TYPE_WORKFLOW_FORM, payload, {
          headers: this.headers
        });

        if (response.data.status === 'success' || response.data.message === 'success') {
          this.show_success('Status unassigned from workflow successfully!');
          this.view_entity_type_workflow_form(this.selected_workflow_id);
        } else {
          this.show_error('Error while unassigning status');
        }
      } catch (error) {
        this.show_error(`Error unassigning workflow statuses: ${error.response?.data?.message}`);
      }
    },    
  }
}